import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { EnterpriseDto } from 'lib';
import { EnterpriseGroupService } from './enterprise-group.service';

@Injectable({
    providedIn: 'root'
})
export class EnterpriseSharedService {
    private enterpriseGroupService = inject(EnterpriseGroupService);

    private enterpriseSubject = new BehaviorSubject<EnterpriseDto | null>(null);
    public enterprise$: Observable<EnterpriseDto | null> = this.enterpriseSubject.asObservable();

    loadEnterprise(enterpriseId: number): Observable<EnterpriseDto> {
        return this.enterpriseGroupService.getEnterprise(enterpriseId).pipe(
            tap(enterprise => this.enterpriseSubject.next(enterprise))
        );
    }

    updateEnterpriseName(name: string): void {
        const currentEnterprise = this.enterpriseSubject.value;
        if (currentEnterprise) {
            this.enterpriseSubject.next({ ...currentEnterprise, name });
        }
    }

    get currentEnterpriseValue(): EnterpriseDto | null {
        return this.enterpriseSubject.value;
    }
}
